<template>
    <div>
        <BaseView>
            <div slot="filter">
                <ProductFilterPanel v-model="filter"
                    :products="allProducts"/>
            </div>

            <div class="flex sm:flex-col md:flex-row items-center">
                <div class="sm:w-full lg:w-1/2 xl:w-1/3 px-2 sm:mb-2 md:m-0">
                    <a-input-search v-model="searchText"
                        placeholder="Procurar..." size="large"/>
                </div>
                <vs-spacer/>
                <div class="sm:p-2">
                    <vs-button class="px-4 sm:w-full md:w-auto" @click="$router.push('/product/add')">
                        <a-icon type="plus" class="mr-2"/>Novo produto
                    </vs-button>
                </div>
            </div>

            <div v-if="!productTypes && !isEmpty" class="w-full text-center" style="margin-top: 15%" >
                <a-spin tip="Carregando..."/>
            </div>
            <div v-else-if="!productTypes && isEmpty">
                <a-empty description="Sem produtos até agora" style="margin-top: 15%" >
                    <a-button type="primary" @click="$router.push('/product/add')">
                        Criar meu primeiro produto
                    </a-button>
                </a-empty>
            </div>
            <div v-else-if="!allProductsWithTextFilter.length">
                <a-empty description="Nada encontrado. Por favor, altere seu filtro." style="margin-top: 15%" />
            </div>
            <vs-list v-else>
                <template v-for="(pType, i) in allProductsWithTextFilter">
                    <vx-card :key="pType.id" card-border no-shadow :class="{ 'mt-2': i }" class="card">
                        <template slot="no-body">
                            <vs-list-header :title="pType.description" class="shadow-none sm:pl-4 pt-4"></vs-list-header>
                            <vs-list-item v-for="product in pType.sortedProducts" :key="product.id"
                                :title="product.description" :subtitle="product.description"
                                class="cursor-pointer hover:shadow hover:bg-grey hover:bg-opacity-25 select-none sm:px-4 px-8"
                                @click.native="viewProduct(product.id)">
                                <template slot="avatar">
                                    <lazy-image :src="product.image"
                                        size="55"
                                        cssClass="product-image mr-6 my-2 object-cover"/>
                                </template>
                                <div class="flex gap-x-4 items-center">
                                    <b class="sm:hidden md:block" style="white-space: nowrap">{{ product.priceDescription }} </b>
                                    <div class="flex flex-col items-end sm:gap-y-2 justify-center">
                                        <b class="sm:block md:hidden" style="white-space: nowrap">{{ product.priceDescription }} </b>
                                        <vs-chip :color="product.enabled ? 'success' : 'warning'" :transparent="!!product.enabled" :class="{ 'fix-css-bug': product.enabled }">
                                            {{ product.enabled ? 'Ativo' : 'Pausado' }}
                                        </vs-chip>
                                    </div>
                                    <a-dropdown :trigger="['click']" class="sm:hidden md:block" @click.native.stop.prevent>
                                        <vs-button type="flat" icon-pack="material-icons" icon="more_vert" size="large" />
                                        <a-menu slot="overlay">
                                            <a-menu-item key="0" @click="toggleProductActive(product, pType.id)">
                                                <a-icon :type="product.enabled ? 'pause' : 'caret-right'" /> {{ product.enabled ? 'Pausar' : 'Retomar' }}
                                            </a-menu-item>
                                            <a-menu-item key="1" @click="duplicateProduct(product, pType.id)">
                                                <a-icon type="copy" /> Duplicar
                                            </a-menu-item>
                                            <!-- <a-menu-item key="2" @click="changeBalance">
                                                <a-icon type="form" /> Editar estoque
                                            </a-menu-item> -->
                                            <a-menu-divider />
                                            <a-menu-item key="6" @click="deleteProduct(product.id, pType.id)">
                                                <b class="text-danger"><a-icon type="delete" class="mr-2"/> Excluir</b>
                                            </a-menu-item>
                                        </a-menu>
                                    </a-dropdown>
                                    <vs-icon icon="keyboard_arrow_right" class="text-3xl sm:hidden md:block"/>
                                </div>
                            </vs-list-item>
                        </template>
                    </vx-card>
                </template>
            </vs-list>
        </BaseView>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Template from '../../components/table/templates/one/Template.vue';
import VxCard from '../../components/vx-card/VxCard.vue';
import LazyImage from '../../components/LazyImage';
import BaseView from '../BaseView.vue'
import ProductFilterPanel from './ProductFilterPanel.vue'

import utils from '@/assets/utils/misc'

import productActionsMixin from './productActionsMixin';
import delayedWatch from '@/mixins/delayed-watch';

    export default {
        mixins: [
            productActionsMixin,
            delayedWatch({ searchText: { handler: 'setTextFilter', timeout: 500, }, }),
        ],
        components: { BaseView, VxCard, Template, LazyImage, ProductFilterPanel },
        data() {
            return {
                filter: {
                    status: 'all',
                    categoryFilter: null,
                    text: ''
                },
                searchText: '',
                debouncedFiltered: [],
                isEmpty: false
            }
        },
        computed: {
            allProducts () {
                if (!this.productTypes)
                    return [];
                return this.productTypes.reduce((prev, curr) => {
                    Object.values(curr.products).forEach(p => prev.push(p));
                    return prev;
                }, []);
            },
            allProductWithCategoryFilter () {
                const indexes = this.filter.categoryFilter?.length;
                if (indexes === 1)
                    return this.productTypes.filter(pt => pt.menu === this.filter.categoryFilter[0]);
                else if (indexes === 2)
                    return [this.productTypes.find(pt => pt.id === this.filter.categoryFilter[1])];
                else
                    return this.productTypes;
            },
            allProductsWithStatusFilter () {
                if (this.filter.status === 'all')
                    return this.allProductWithCategoryFilter;
                const byActive = this.filter.status === 'active';
                const results = [];
                this.allProductWithCategoryFilter.forEach(productType => {
                    const products = Object.values(productType.sortedProducts)
                            .filter(p => !!p.enabled == byActive);
                    if (products.length) {
                        const cpyProductType = Object.assign({}, productType);
                        cpyProductType.sortedProducts = products;
                        results.push(cpyProductType);
                    }
                });
                return results;
            },
            allProductsWithTextFilter () {
                if (this.filter.length < 3)
                    return this.allProductsWithStatusFilter;
                const text = utils.removeSpecialChars(this.filter.text);
                const results = [];
                this.allProductsWithStatusFilter.forEach(productType => {
                    const productTypeMatches = utils.removeSpecialChars(productType.description).includes(text);
                    if (productTypeMatches)
                        results.push(productType);
                    else {
                        const products = Object.values(productType.sortedProducts)
                            .filter(p => utils.removeSpecialChars(p.description).includes(text) || utils.removeSpecialChars(p.details).includes(text));
                        if (products.length) {
                            const cpyProductType = Object.assign({}, productType);
                            cpyProductType.sortedProducts = products;
                            results.push(cpyProductType);
                        }
                    }
                });
                return results;
            },
            shouldFilter () { return this.filter.length > 2; },
            ...mapGetters('productType', { 'productTypes': 'productTypesOrderedByMenu', 'menus': 'companyMenus' }),
        },
        methods: {
            viewProduct (productId) {
                this.$router.push(`/product/edit/${productId}`)
            },
            setTextFilter () {
                this.filter.text = this.searchText;
            },
            ...mapActions('productType', ['fetchProductTypes', 'fetchMenus']),
        },
        async mounted () {
            await this.fetchMenus();
            await this.fetchProductTypes();
            setTimeout(() => {
                if (!this.productTypes?.length)
                    this.isEmpty = true;
            }, 2500);
        },
    }
</script>

<style lang="scss" scoped>
.product-image {
    border-radius: 8px;
}
.card::v-deep .vx-card__body {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}
.card::v-deep .vs-list--title {
    font-size: 12pt;
}
.fix-css-bug {
    color: rgba(var(--vs-success),1) !important;
}
</style>